/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.check\":[\"Valintamerkki\"]}");